import React, { useContext, useEffect } from 'react'
import { useNavigate } from 'react-router-dom' // Імпортуємо useNavigate
import { clearProjectAction, NewProjectButton } from '../project'
import { Hero } from '../logo'
import { LogoutButton } from '../logout/LogoutButton'
import { AppContext } from '../App'
import { HistoryIcon } from '../icons/HistoryIcon'
import { Version } from '../version'

const Home = () => {
  const { dispatch } = useContext(AppContext)
  const navigate = useNavigate()

  useEffect(() => {
    dispatch(clearProjectAction())
  }, [dispatch])

  return (
    <div className='container py-10 px-10 mx-0 min-w-full min-h-full flex flex-col items-center justify-center overflow-hidden'>
      <div className='flex flex-col items-center min-w-full'>
        <Hero />
        <NewProjectButton />
        <button
          className='slate-500 mt-5 flex items-center gap-2'
          onClick={() => navigate('/history')}
        >
          <HistoryIcon />
          History
        </button>
        <LogoutButton />
      </div>
      <Version />
    </div>
  )
}

export { Home }
